import React, { memo } from 'react';
import BasicCellRenderer from './BasicCellRenderer';

export default (props) => (
    <BasicCellRenderer {...props} iconClassName='icon-calendar52' />
);
